<template>
  <div class="col px-0 contact d-flex flex-column">
    <div class="content-title mb-5">
      <div class="media">
        <div class="media-body">
          <h1>
            {{ $t("feature.greeting.title") }}
          </h1>
          <div class="alert alert-warning download-report-message mb-2">
            เลือก ช่วงเวลา ที่ต้องการก่อนกด Download Report
          </div>
          <div class="row">
            <div class="ms-3">
              <el-date-picker
                :value="dateTimeReport"
                class="date-picker"
                type="daterange"
                range-separator="ถึง"
                @input="handleChangeDate($event)"
              ></el-date-picker>
            </div>
            <div class="ms-3">
              <sc-button
                variant="secondary"
                @click="handleClickDownloadReport"
              >Download Report</sc-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import { DatePicker } from "element-ui";
import { DateTime } from "luxon";

import { baanRueJaiClient } from "@/dependencies";
import ScButton from "@/lib/components/ScButton";

const GREETING_CONTACT_CATEGORY_ID = 4;
const XLSX_MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export default {
  components: {
    ScButton,
    "el-date-picker": DatePicker
  },
  data() {
    const selectedDateTimeReport = null;

    return {
      selectedDateTimeReport
    };
  },
  computed: {
    dateTimeReport() {
      if (!this.selectedDateTimeReport) {
        return null;
      }

      const { from, to } = this.selectedDateTimeReport;

      return [from.setZone("local").toJSDate(), to.setZone("local").toJSDate()];
    }
  },
  methods: {
    handleChangeDate(value) {
      if (!value) {
        this.selectedDateTimeReport = null;
        return;
      }
      const [fromJSDate, toJSDate] = value;
      const from = DateTime.fromJSDate(fromJSDate).startOf("day").toUTC();
      const to = DateTime.fromJSDate(toJSDate)
        .endOf("day")
        .toUTC();

      this.selectedDateTimeReport = { from, to };
    },
    async handleClickDownloadReport() {
      if (!this.selectedDateTimeReport) {
        this.$message.error("กรุณาเลือกช่วงเวลาก่อน Download Report");
        return;
      }

      const { from, to } = this.selectedDateTimeReport;

      try {
        const response = await baanRueJaiClient.admin.greeting.getReport(
          {
            start_at: from.toISO(),
            end_at: to.toISO(),
            contact_category_id: GREETING_CONTACT_CATEGORY_ID
          }
        );

        const blob = new Blob([response.data], { type: XLSX_MIME_TYPE });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `report-greeting-${from.toISODate()}-${to.toISODate()}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        const message = error?.response?.data?.message
          || "ไม่สามารถ Download Report ได้ เนื่องจากไม่มีข้อมูลหรือเกิดข้อผิดพลาด";
        this.$message.error(message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.download-report-message {
  font-size: 15px;
}
</style>